// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"11d90f5e52a59b58","1221":"2f8daefc5b589185","3602":"5c3c4c2d80e02820","4937":"a94b6179624b7cad"}[chunkId] + ".css";
};